import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
interface VersionUpdateModalProps {
  open: boolean;
  onDismiss: () => void;
  onReload: () => void;
}

/**
 * Modal dialog that prompts users to reload when a new version is available.
 * Uses AlertDialog to require user interaction (can't be dismissed by clicking outside).
 */
export function VersionUpdateModal({
  open,
  onDismiss,
  onReload,
}: VersionUpdateModalProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Update Available</AlertDialogTitle>
          <AlertDialogDescription>
            A new version of Sked is available. Reload to get the latest
            features and improvements.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onDismiss}>Later</AlertDialogCancel>
          <AlertDialogAction onClick={onReload}>Reload Now</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
